import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoadingService } from '../services/loading.service';

/**
 * Loading Interceptor
 * - Shows global loading indicator during HTTP requests
 * - Handles concurrent requests (counter-based)
 * - Skip loading with X-Skip-Loading header
 */
export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);

  // Skip loading indicator for specific requests
  if (req.headers.has('X-Skip-Loading')) {
    const newReq = req.clone({
      headers: req.headers.delete('X-Skip-Loading')
    });
    return next(newReq);
  }

  // Skip loading for certain request types (optional)
  const skipMethods = ['OPTIONS'];
  if (skipMethods.includes(req.method)) {
    return next(req);
  }

  loadingService.show();

  return next(req).pipe(
    finalize(() => loadingService.hide())
  );
};